export default __webpack_public_path__ + "static/media/type_17_3.1468f6c7.svg";